export function getDeactivatedAccessMessage(error: unknown) {
  if (!error || typeof error !== 'object') {
    return null;
  }

  const response = 'response' in error ? (error as { response?: Response }).response : undefined;
  const status = response?.status;

  if (status === 400) {
    return 'Your account is currently inactive. Please contact your administrator to request access.';
  }

  return null;
}
